import type { ReactNode } from 'react'

import styles from './Feedback.module.css'

interface EmptyStateProps {
  readonly title: string
  /**
   * What to do about it.
   *
   * An empty state saying only "No entries" tells the user something they can
   * already see. The useful half is the next step, which is why this is
   * required rather than optional.
   */
  readonly body: ReactNode
  readonly action?: ReactNode
}

export function EmptyState({ title, body, action }: EmptyStateProps) {
  return (
    <div className={styles['empty']}>
      <p className={styles['emptyTitle']}>{title}</p>
      <p className={styles['emptyBody']}>{body}</p>
      {action}
    </div>
  )
}
